import { Customer, CustomerSortKey } from "@/repositories/client.repository";
import { z } from "zod";

export interface ClientState {
  list: Customer[];
  loading: boolean;
  error: string | null;
  total: number;
  filters: {
    page: number;
    pageSize: number;
    name: string;
    sortKey: CustomerSortKey;
    sortOrder: "asc" | "desc";
  };
}

export const customerContactSchema = z.object({
  name: z.string().trim().min(1, "Name is required"),
  email: z.string().email("Invalid email"),
  phone: z.string().optional(),
  designation: z.string().optional(),
});

export type CustomerContactFormValues = z.infer<typeof customerContactSchema>;
